import SegmentPage from "@/pages/SegmentPage";

export function HomeownersPage() {
    return (
        <SegmentPage
            testid="homeowners-page"
            chip="Homeowners"
            title="Compare residential electricity plans for"
            highlight="the home you own."
            subtitle="Fixed-rate, variable-rate, renewal options - we help you review contract terms, base fees, and early-exit terms before you decide anything."
            bullets={[
                "Review fixed vs variable plans",
                "Understand base fees & contract length",
                "No auto-enrollment, ever",
                "Zero cost comparison help",
            ]}
            initial={{ customer_type: "homeowner" }}
            source="homeowners"
            imageUrl="https://images.unsplash.com/photo-1758687126877-b37052a20a4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxoYXBweSUyMGZhbWlseSUyMGhvbWUlMjBlbmVyZ3klMjBzYXZpbmdzfGVufDB8fHx8MTc5MDk5OTExM3ww&ixlib=rb-4.1.0&q=85"
            seoTitle="Compare Residential Electricity Plans"
            seoDescription="Homeowners: compare available electricity plans, rates, and contract terms. Independent help from PowerSaver TX."
        />
    );
}

export function RentersPage() {
    return (
        <SegmentPage
            testid="renters-page"
            chip="Renters"
            title="Electricity for apartments,"
            highlight="condos, and rentals."
            subtitle="Moving into a new place or already renting? We'll help you set up or review your electricity account - fast."
            bullets={[
                "Setup for first-time renters",
                "Switch providers if allowed",
                "Short-term lease friendly plans",
                "Text or call - your choice",
            ]}
            initial={{ customer_type: "renter" }}
            source="renters"
            imageUrl="https://images.unsplash.com/photo-1622790410882-c1f00a56083e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxoYXBweSUyMGZhbWlseSUyMGhvbWUlMjBlbmVyZ3klMjBzYXZpbmdzfGVufDB8fHx8MTc5MDk5OTExM3ww&ixlib=rb-4.1.0&q=85"
            seoTitle="Electricity Options for Renters & Apartments"
            seoDescription="Renters: compare electricity plan options for apartments, condos, and houses. Independent help from PowerSaver TX."
        />
    );
}

export function MovingPage() {
    return (
        <SegmentPage
            testid="moving-page"
            chip="Moving soon"
            title="Need electricity connected"
            highlight="before your move-in?"
            subtitle="Tell us your move date and ZIP - we'll help you line up service so the lights are on when you arrive."
            bullets={[
                "Same-week connections where available",
                "Compare providers in your new area",
                "Avoid double-billing from old service",
                "Transparent fees upfront",
            ]}
            initial={{ customer_type: "moving", situation: "I need electricity at a new address" }}
            source="moving"
            imageUrl="https://images.pexels.com/photos/3584283/pexels-photo-3584283.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            seoTitle="Electricity Setup for Moving"
            seoDescription="Moving soon? Get help connecting electricity at your new address. Independent help from PowerSaver TX."
        />
    );
}

export function FirstTimePage() {
    return (
        <SegmentPage
            testid="first-time-page"
            chip="First-time customers"
            title="Setting up your"
            highlight="first electricity account?"
            subtitle="We walk you through it in plain English. No surprises, no confusing jargon, no sales pressure."
            bullets={[
                "Beginner-friendly guidance",
                "Understand deposits & credit",
                "Avoid common fees",
                "Call or text - we respond fast",
            ]}
            initial={{ customer_type: "other", situation: "I need electricity at a new address" }}
            source="first-time"
            imageUrl="https://images.unsplash.com/photo-1622790410882-c1f00a56083e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxoYXBweSUyMGZhbWlseSUyMGhvbWUlMjBlbmVyZ3klMjBzYXZpbmdzfGVufDB8fHx8MTc5MDk5OTExM3ww&ixlib=rb-4.1.0&q=85"
            seoTitle="First-Time Electricity Setup"
            seoDescription="New to electricity service? Independent, beginner-friendly help setting up your first plan."
        />
    );
}

export function ExistingPage() {
    return (
        <SegmentPage
            testid="existing-page"
            chip="Existing customers"
            title="Contract ending or"
            highlight="just overpaying?"
            subtitle="If your plan is expiring or renewed at a high rate, we'll help you see what else is available in your area."
            bullets={[
                "Review current plan vs available",
                "Spot hidden renewal rate hikes",
                "Compare early-exit vs waiting",
                "No obligation to switch",
            ]}
            initial={{ customer_type: "homeowner", situation: "My contract is ending soon" }}
            source="existing"
            imageUrl="https://images.unsplash.com/photo-1758687126877-b37052a20a4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxoYXBweSUyMGZhbWlseSUyMGhvbWUlMjBlbmVyZ3klMjBzYXZpbmdzfGVufDB8fHx8MTc5MDk5OTExM3ww&ixlib=rb-4.1.0&q=85"
            seoTitle="Compare Current Electricity Plan"
            seoDescription="Review your current plan or renewal. See what else is available in your area. Independent help."
        />
    );
}

export function BusinessPage() {
    return (
        <SegmentPage
            testid="business-page"
            chip="Small business"
            title="Electricity options for"
            highlight="restaurants, shops & offices."
            subtitle="Share your business type, ZIP, and approximate monthly usage - we'll help you compare commercial plan options."
            bullets={[
                "Restaurants, salons, retail, offices",
                "Multi-location friendly",
                "Review fixed vs indexed commercial",
                "No fake savings claims",
            ]}
            initial={{ customer_type: "business", situation: "I need electricity for my business" }}
            source="business"
            imageUrl="https://images.unsplash.com/photo-1531058240690-006c446962d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxzbWFsbCUyMGJ1c2luZXNzJTIwb3duZXIlMjByZXRhaWwlMjBzdG9yZSUyMHNob3B8ZW58MHx8fHwxNzkwOTk5MTEzfDA&ixlib=rb-4.1.0&q=85"
            seoTitle="Electricity Options for Small Businesses"
            seoDescription="Commercial electricity help for restaurants, shops, offices, warehouses. Compare plan options."
        />
    );
}

export function TexasPage() {
    return (
        <SegmentPage
            testid="texas-page"
            chip="Texas"
            title="Compare electricity plans"
            highlight="across Texas."
            subtitle="From Houston to Dallas to Austin and beyond - we help Texans explore plans in their service territory."
            bullets={[
                "CenterPoint, Oncor, AEP, TNMP territories",
                "Residential + commercial",
                "Transparent contract terms",
                "Texans helping Texans",
            ]}
            initial={{ state: "TX" }}
            source="texas-seo"
            imageUrl="https://images.pexels.com/photos/3584283/pexels-photo-3584283.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            seoTitle="Compare Electricity Plans in Texas"
            seoDescription="Texas electricity plan comparison. Residential and commercial. Independent help from PowerSaver TX."
        />
    );
}

export function HoustonPage() {
    return (
        <SegmentPage
            testid="houston-page"
            chip="Houston"
            title="Houston electricity"
            highlight="plan comparison."
            subtitle="Serving Houston neighborhoods in the CenterPoint utility territory. Call or text us local at (713) 205-2971."
            bullets={[
                "CenterPoint Energy territory",
                "Fast local turnaround",
                "Apartment-friendly",
                "Small-business friendly",
            ]}
            initial={{ state: "TX", utility_territory: "CenterPoint" }}
            source="houston-seo"
            imageUrl="https://images.pexels.com/photos/3584283/pexels-photo-3584283.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            seoTitle="Houston Electricity Plan Comparison"
            seoDescription="Houston electricity plan help for homes and businesses. Independent comparison service."
        />
    );
}

export function FixedRatePage() {
    return (
        <SegmentPage
            testid="fixed-rate-page"
            chip="Fixed rate"
            title="Compare fixed-rate"
            highlight="electricity plans."
            subtitle="Prefer a locked-in rate? We help you compare fixed-rate options and understand the full contract terms."
            bullets={[
                "6-, 12-, 24-, 36-month plans",
                "Lock in through peak seasons",
                "Understand early-exit terms",
                "Clear base fees upfront",
            ]}
            source="fixed-rate-seo"
            imageUrl="https://images.unsplash.com/photo-1758687126877-b37052a20a4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxoYXBweSUyMGZhbWlseSUyMGhvbWUlMjBlbmVyZ3klMjBzYXZpbmdzfGVufDB8fHx8MTc5MDk5OTExM3ww&ixlib=rb-4.1.0&q=85"
            seoTitle="Compare Fixed-Rate Electricity Plans"
            seoDescription="Fixed-rate electricity plan comparison. Lock in your rate. Independent, no-pressure help."
        />
    );
}
